import { PaymentMethodType } from "client/openapi";

export default function EmailOption({
  email,
  selectable = false,
  onRadioSelect,
  radioRef,
  defaultSelected,
}: {
  email: string;
  selectable?: boolean;
  onRadioSelect?: (
    paymentMethod: string,
    paymentMethodType: PaymentMethodType
  ) => void;
  radioRef?: (element: HTMLInputElement | null) => void;
  defaultSelected?: boolean;
}) {
  return (
    <tr className="header text-sm align-top">
      <td className="flex gap-2 font-normal mb-1 items-center">
        {selectable && onRadioSelect && (
          <input
            type="radio"
            name="bill-to"
            defaultChecked={defaultSelected}
            onChange={() => {
              onRadioSelect(email, PaymentMethodType.INVOICE);
            }}
            ref={radioRef}
          />
        )}
        <p className="text-nowrap whitespace-nowrap">{email}</p>
      </td>
    </tr>
  );
}
